import { render, staticRenderFns } from "./NoticeEdit.vue?vue&type=template&id=73b058fc&scoped=true&"
import script from "./NoticeEdit.vue?vue&type=script&lang=ts&"
export * from "./NoticeEdit.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeEdit.vue?vue&type=style&index=0&id=73b058fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b058fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
